module.exports = ['customer.top_menu.m1', 'customer.top_menu.m3', 'customer.top_menu.m4', 'artprice.client.default.m2', 'customer._top_menu_level_1.m2'];
